import { render, staticRenderFns } from "./gasdata.vue?vue&type=template&id=3370317e&scoped=true&"
import script from "./gasdata.vue?vue&type=script&lang=ts&"
export * from "./gasdata.vue?vue&type=script&lang=ts&"
import style0 from "./gasdata.vue?vue&type=style&index=0&id=3370317e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3370317e",
  null
  
)

export default component.exports